<template>
  <ul class="list-custom__table detail-navi">
      <li class="full prev" v-if="prevNextPost.prevPostNo">
          <span>이전글</span>
          <p>
              <a href="javascript:void(0);" v-if="prevNextPost.prevPostNo" @click="doPrevNext(prevNextPost.prevPostNo)">
                {{ prevNextPost.prevPostTitle }}
              </a>
          </p>
      </li>
      <li class="full next" v-if="prevNextPost.nextPostNo">
          <span>다음글</span>
          <p>
              <a href="javascript:void(0);" v-if="prevNextPost.nextPostNo" @click="doPrevNext(prevNextPost.nextPostNo)">
                {{ prevNextPost.nextPostTitle }}
              </a>
          </p>
      </li>
  </ul>
</template>

<script>
export default {
  props: {
    value: {
      type: Object
    },
    prevNextPost: {
      type: Object
    },
    board: {
      type: Object
    },
    routeDiv: {

    }
  },
  data() {
    return {
      searchParam: {
        contentNo: null,
        postNo: null,
        attcNo: null,
        originBoardNo: null,
        boardDepth: null,
      },
    }
  },
  methods: {
    doPrevNext(postNo) {
      if(postNo != null && postNo != '') {
        this.searchParam.postNo = postNo;
        const qeury = {...this.$route.query}
        qeury.postNo = postNo.toString();
        this.$router.push({query: qeury});
      }
    },
    doWrite() {
      const query = {...this.$route.query};
      delete query.postNo;
    
      this.$router.push({name: `${this.routeDiv}Modify`, query: query});
    },
    doModify() {
      this.$router.push({name:`${this.routeDiv}Modify`, query: this.$route.query});
    },
    doBoard() {
      if(this.board.writeYn == 'Y') {
        this.setSearchParam();
        this.$tran('/site/external/contents/selectIsValidDel', this.searchParam).then(response => {
          if(response.data.isToken){
            this.doDelete();
          }else{
            this.doPwDel(); 
          }
        })
      }
    },
    doPwDel() {
      this.$swal.fire({
        title: '비밀번호 입력',
        input: 'password',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        showLoaderOnConfirm: true,
        confirmButtonColor: '#08a17b',
        preConfirm: (password) => {
          this.searchParam.inputPw = password;
          this.setSearchParam();

          return this.$tran('/site/external/contents/deletePostChk', this.searchParam).then(response => {
            if(!response.data.isToken) {
              throw new Error();
            }

            return response.data.isToken
          })
          .catch(error => {
            this.$swal.showValidationMessage('비밀번호가 일치하지 않습니다.')
          })
        },
        allowOutsideClick: () => this.$swal.isLoading()
      })
      .then((result) => {
        if(result.isConfirmed) {
          this.doDelete();
        }
      })
    },
    doDelete() {
      this.setSearchParam();
      this.$tran('/site/external/contents/deletePost', this.searchParam).then(response => {
        this.$nextTick(() => {
          this.doList()
        })
      })
    },
    setSearchParam() {
      this.searchParam.contentNo = this.value.boardNo;
      this.searchParam.postNo = this.value.postNo;
      this.searchParam.attcNo = this.value.attcNo;
      this.searchParam.originBoardNo = this.value.originBoardNo;
      this.searchParam.boardDepth = this.value.boardDepth;
    },
    doList() {
      let name = 'content'
      const query = {...this.$route.query};

      delete query.postNo
      delete query.orginPostNo

      if(this.routeDiv == 'direct') {
        name = 'directBoard'
      }
      
      this.$router.push({name: name, query: query})
    },
    doReply() {
      const query = {...this.$route.query};
      query.orginPostNo = query.postNo;
      delete query.postNo;
      
      this.$router.push({name:`${this.routeDiv}Modify`, query: query})
    },
  }
}
</script>